export class LogicConstants {


  static PURCHASE_ORDER_RECEIPT_PAYMENT_OPEN_STATUS = "O";
  static PURCHASE_ORDER_RECEIPT_PAID_STATUS = "F";
  static PURCHASE_ORDER_RECEIPT_PARTIALLY_PAID_STATUS = "P";

  static PURCHASE_ORDER_PAYMENT_OPEN_STATUS = "O";
  static PURCHASE_ORDER_PAID_STATUS = "F";
  static PURCHASE_ORDER_PARTIALLY_PAID_STATUS = "P";

  static LOGIN_TYPE_NORMAL_USER = "G";
  static LOGIN_TYPE_ADMIN_USER = "A";
  static LOGIN_TYPE_CUSTOMER_USER = "C";
  static LOGIN_TYPE_VENDOR_USER = "V";
  static LOGIN_TYPE_RETAIL_USER = "R";
  //#region SalesOrder
  static SALES_ORDER_APPROVE_STATUS = "A";
  static SALES_ORDER_UNAPPROVE_STATUS = "U";
  static SALES_ORDER_CANCEL_STATUS = "X";
  static SALES_ORDER_CLOSE_STATUS = "H";
  static SALES_ORDER_INVOICED_STATUS = "F";
  static SALES_ORDER_PICKED_STATUS = "M";
  static SALES_ORDER_PARTIALLY_PICKED_STATUS = "L";
  static SALES_ORDER_PARTIALLY_INVOICED_STATUS = "G";
  static SALES_ORDER_LINE_OPEN_STATUS = "O";
  static SALES_ORDER_LINE_APPROVE_STATUS = "A";
  static SALES_ORDER_LINE_SHIPPED_STATUS = "F"; // Shipped / Finished
  static SALES_ORDER_LINE_CANCEL_STATUS = "X"; // Cancelled becos of Customer mistakes / problems
  static SALES_ORDER_LINE_CLOSE_STATUS = "H"; // Closed. becos of the Company requirement // Manual Close
  static SALES_ORDER_LINE_SHIPED_CANCEL_STATUS = "E"; // Shipped and Cancelled
  static SALES_ORDER_LINE_SHIPED_CLOSE_STATUS = "G"; // Shiped and Closed
  static SALES_ORDER_LINE_PARTIALLY_SHIPPED_STATUS = "C";
  static SALES_ORDER_LINE_PACKED_STATUS = "N";
  static SALES_ORDER_LINE_PARTIALLY_PACKED_STATUS = "Q";
  static SALES_ORDER_LINE_PACKED_CANCEL_STATUS = "W";
  static SALES_ORDER_LINE_PACKED_CLOSE_STATUS = "Z";
  //#endregion
  //#region PickTicket
  static PICK_TICKET_APPROVE_STATUS = "A";
  static PICK_TICKET_UNAPPROVE_STATUS = "U";
  static PICK_TICKET_CANCEL_STATUS = "X";
  static PICK_TICKET_PICKED_STATUS = "P";
  static PICK_TICKET_PARTIALLY_PICKED_STATUS = "K";
  static PICK_TICKET_INVOICED_STATUS = "F";
  static PICK_TICKET_PARTIALLY_INVOICED_STATUS = "I";
  //#endregion
  //#region PickTicket
  static PICK_TICKET_LINE_OPEN_STATUS = "O";
  static PICK_TICKET_LINE_APPROVE_STATUS = "A";
  static PICK_TICKET_LINE_PICKED_STATUS = "P";
  static PICK_TICKET_LINE_PARTIALLY_PICKED_STATUS = "K";
  static PICK_TICKET_LINE_INVOICED_STATUS = "F";
  static PICK_TICKET_LINE_PARTIALLY_INVOICED_STATUS = "I";
  //#endregion
  //#region invoice
  static INVOICE_APPROVE_STATUS = "A";
  static INVOICE_UNAPPROVE_STATUS = "U";
  static INVOICE_OPEN_STATUS = "O";
  static INVOICE_PAID_STATUS = "F";
  static INVOICE_PARTIALLY_PAID_STATUS = "P";
  static INVOICE_CANCEL_STATUS = "X";
  //#endregion
  //#region invoice Line
  static INVOICE_LINE_OPEN_STATUS = "O";
  static INVOICE_LINE_APPROVE_STATUS = "A";
  //#endregion
  //#region invoice Service Line
  static INVOICE_SERVICE_LINE_OPEN_STATUS = "O";
  static INVOICE_SERVICE_LINE_CANCEL_STATUS = "X";
  //#endregion
  //#region Account Receivable
  static ACCOUNT_RECEIVABLE_OPEN_STATUS = "O";
  static ACCOUNT_RECEIVABLE_FINISHED_STATUS = "F";
  static ACCOUNT_RECEIVABLE_CANCEL_STATUS = "X";
  static ACCOUNT_RECEIVABLE_REVERSE_STATUS = "R"; //cancel and return
  //#endregion
  //#region CreditMemo
  static CREDIT_MEMO_OPEN_STATUS = "O";
  static CREDIT_MEMO_UNAPPROVE_STATUS = "U";
  static CREDIT_MEMO_APPROVE_STATUS = "A";
  static CREDIT_MEMO_CANCEL_STATUS = "X";
  static CREDIT_MEMO_FINISHED_STATUS = "F";
  static CREDIT_MEMO_PARTIALLY_CLOSED_STATUS = "P";
  static CREDIT_MEMO_PARTIALLY_USED_AND_APPROVED_STATUS = "C";
  //#endregion
  //#region CreditMemo Line
  static CREDIT_MEMO_LINE_OPEN_STATUS = "O";
  static CREDIT_MEMO_LINE_APPROVE_STATUS = "A";
  static CREDIT_MEMO_LINE_CANCEL_STATUS = "X";
  //#endregion
  //# region PurchaseOrder
  static PURCHASE_ORDER_APPROVE_STATUS = "A";
  static PURCHASE_ORDER_UNAPPROVE_STATUS = "U";
  static PURCHASE_ORDER_CANCEL_STATUS = "X";
  static PURCHASE_ORDER_RECEIVED_STATUS = "R";
  static PURCHASE_ORDER_PARTIALLY_RECEIVED_STATUS = "I";
  static PURCHASE_ORDER_FORCE_CLOSED_STATUS = "H";
  //#endregion
  //# region PurchaseOrder Line
  static PURCHASE_ORDER_LINE_OPEN_STATUS = "O";
  static PURCHASE_ORDER_LINE_CANCEL_STATUS = "X";
  static PURCHASE_ORDER_LINE_RECEIVED_STATUS = "F";
  static PURCHASE_ORDER_LINE_CLOSE_STATUS = "H";
  static PURCHASE_ORDER_LINE_RECEIVED_CANCEL_STATUS = "E";
  static PURCHASE_ORDER_LINE_RECEIVED_CLOSE_STATUS = "G";
  static PURCHASE_ORDER_LINE_PARTIALLY_RECEIVED = "I";
  //#endregion
  //# region PurchaseOrder Receipt
  static PURCHASEORDER_RECEIPT_APPROVE_STATUS = "A";
  static PURCHASEORDER_RECEIPT_UNAPPROVE_STATUS = "U";
  static PURCHASEORDER_RECEIPT_CANCEL_STATUS = "X";

  //#endregion
  //# region PurchaseOrder Receipt Line
  static PURCHASEORDER_RECEIPT_LINE_OPEN_STATUS = "O";
  static PURCHASEORDER_RECEIPT_LINE_CANCEL_STATUS = "X";
  //#endregion
  //# region PurchaseOrder InTransit
  static PURCHASEORDER_INTRANSIT_APPROVE_STATUS = "A";
  static PURCHASEORDER_INTRANSIT_UNAPPROVE_STATUS = "U";
  static PURCHASEORDER_INTRANSIT_CANCEL_STATUS = "X";
  static PURCHASEORDER_INTRANSIT_RECEIVED_STATUS = "F";
  static PURCHASE_ORDER_INTRANSIT_PARTIALLY_RECEIVED_STATUS = "P";
  //#endregion
  //# region PurchaseOrder InTransit Line
  static PURCHASE_ORDER_INTRANSIT_LINE_OPEN_STATUS = "O";
  static PURCHASE_ORDER_INTRANSIT_LINE_CANCEL_STATUS = "X";
  static PURCHASE_ORDER_INTRANSIT_LINE_RECEIVED_STATUS = "F";
  //#endregion
  //# region Deposit
  static DEPOSIT_OPEN_STATUS = "O";
  static DEPOSIT_APPROVED_STATUS = "A";
  //#endregion
  //#region Check Transaction
  static CHECK_TRANSACTION_OPEN_STATUS = "O";
  //static CHECK_TRANSACTION_POSTED_STATUS = "F";
  static CHECK_TRANSACTION_PRINTED_STATUS = "P";
  // static CHECK_TRANSACTION_CANCEL_STATUS = "X";
  static CHECK_TRANSACTION_VOIDED_STATUS = "V";
  //#endregion
  //# region PurchaseOrder Receipt
  static VENDOR_INVOICE_OPEN_STATUS = "O";
  static VENDOR_INVOICE_APPROVE_STATUS = "A";
  static VENDOR_INVOICE_UNAPPROVE_STATUS = "U";
  static VENDOR_INVOICE_CANCEL_STATUS = "X";
  static VENDOR_INVOICE_PAID_STATUS = "F";
  static VENDOR_INVOICE_PARTIALLY_PAID_STATUS = "P";
  //#endregion
  //# region BankAdjustment
  static BANK_ADJUSTMENT_OPEN_STATUS = "O";
  static BANK_ADJUSTMENT_APPROVED_STATUS = "A";
  //#endregion
  //# region Letter Of Credit
  static LETTER_OF_CREDIT_OPEN_STATUS = "O";
  static LETTER_OF_CREDIT_UNAPPROVED_STATUS = "U";
  //#endregion
  //# region CheckBounce
  static CHECK_BOUNCE_OPEN_STATUS = "O";
  static CHECK_BOUNCE_UNAPPROVED_STATUS = "U";
  static CHECK_BOUNCE_APPROVED_STATUS = "A";
  //#endregion
  //#region Customer Return
  static CUSTOMER_RETURN_OPEN_STATUS = "O";
  static CUSTOMER_RETURN_UNAPPROVE_STATUS = "U";
  static CUSTOMER_RETURN_APPROVE_STATUS = "A";
  static CUSTOMER_RETURN_CANCEL_STATUS = "X";
  static CUSTOMER_RETURN_FINISHED_STATUS = "F";
  static CUSTOMER_RETURN_LINE_OPEN_STATUS = "O";
  static CUSTOMER_RETURN_LINE_APPROVE_STATUS = "A";
  static CUSTOMER_RETURN_LINE_CANCEL_STATUS = "X";
  //#endregion
  //#region CPM Stage
  static PRE_PRODUCTION_STAGE_OPEN_STATUS = "O";
  static PRE_PRODUCTION_STAGE_PARTIALLAY_APPROVE_STATUS = "P";
  static PRE_PRODUCTION_STAGE_APPROVE_STATUS = "A";
  static PRE_PRODUCTION_STAGE_CANCEL_STATUS = "X";
  static PRE_PRODUCTION_STAGE_NOT_APPLICABLE_STATUS = "N";
  static PRE_PRODUCTION_STAGE_FAIL_STATUS = "F";
  //#endregion
  //#region CPM Cycle
  static PRE_PRODUCTION_CYCLE_OPEN_STATUS = "O";
  static PRE_PRODUCTION_CYCLE_UNAPPROVE_STATUS = "U";
  static PRE_PRODUCTION_CYCLE_APPROVE_STATUS = "A";
  static PRE_PRODUCTION_CYCLE_CANCEL_STATUS = "X";
  static PRE_PRODUCTION_CYCLE_SUBMITTED_STATUS = "S";
  static PRE_PRODUCTION_CYCLE_RE_SUBMITTED_STATUS = "R";
  //#endregion
  //#region CPM
  static PRE_PRODUCTION_OPEN_STATUS = "O";
  static PRE_PRODUCTION_UNAPPROVE_STATUS = "U";
  static PRE_PRODUCTION_APPROVE_STATUS = "A";
  static PRE_PRODUCTION_CANCEL_STATUS = "X";
  static PRE_PRODUCTION_SUBMITTED_STATUS = "S";
  static PRE_PRODUCTION_RE_SUBMITTED_STATUS = "R";
  static PRE_PRODUCTION_FINISHED_STATUS = "F";
  //#endregion
  //#region EcomWebOrderStatusDetails
  static DATA_UPLOAD_JOB_FINISH_STATUS = "F";
  static DATA_UPLOAD_JOB_ERROR_STATUS = "E";
  //#endregion
  //# region LogisticOrder
  static LOGISTIC_ORDER_UNAPPROVE_STATUS = "U";
  static LOGISTIC_ORDER_APPROVE_STATUS = "A";
  static LOGISTIC_ORDER_CANCEL_STATUS = "X";
  static LOGISTIC_ORDER_CLOSE_STATUS = "H";
  static LOGISTIC_ORDER_RECEIVED_STATUS = "R";
  static LOGISTIC_ORDER_PARTIALLY_RECEIVED_STATUS = "I";
  //#endregion
  //# region LogisticOrder Line
  static LOGISTIC_ORDER_LINE_RECEIVED_CANCEL_STATUS = "E"; // Received and Cancelled
  static LOGISTIC_ORDER_LINE_RECEIVED_CLOSE_STATUS = "G"; // Received and Closed
  static LOGISTIC_ORDER_LINE_RECEIVED_STATUS = "F";
  static LOGISTIC_ORDER_LINE_CANCEL_STATUS = "X"; // Cancelled becos of Customer mistakes / problems
  static LOGISTIC_ORDER_LINE_CLOSE_STATUS = "H";
  static LOGISTIC_ORDER_LINE_OPEN_STATUS = "O";
  static LOGISTIC_ORDER_LINE_PARTIALLY_RECEIVED_STATUS = "I";
  //#endregion
  //# region LogisticOrderReceipt
  static LOGISTIC_ORDER_RECEIPT_UNAPPROVE_STATUS = "U";
  static LOGISTIC_ORDER_RECEIPT_CANCEL_STATUS = "X";
  static LOGISTIC_ORDER_RECEIPT_APPROVE_STATUS = "A";
  //#endregion
  //# region LogisticOrderReceipt Line
  static LOGISTIC_ORDER_RECEIPT_LINE_CANCEL_STATUS = "X"; // Cancelled becos of Customer mistakes / problems
  static LOGISTIC_ORDER_RECEIPT_LINE_OPEN_STATUS = "O";
  static LOGISTIC_ORDER_RECEIPT_LINE_CLOSE_STATUS = "H";
  //#endregion

  //#region Post Dated Check
  static POST_DATED_CHECKENTRY_OPEN_STATUS = "O";
  static POST_DATED_CHECKENTRY_FINISHED_STATUS = "F";
  static POST_DATED_CHECKENTRY_CANCEL_STATUS = "X";
  static POST_DATED_CHECKENTRY_REVERSE_STATUS = "R"; //cancel and return
  static POST_DATED_CHECKENTRY_UNAPPROVE_STATUS = "U";
  static POST_DATED_CHECKENTRY_APPROVE_STATUS = "A";
  //#endRegion

  static LOGIN_TYPE_EMPLOYEE_USER = "E";
  static LOGIN_TYPE_SALES_PERSON_USER = "S";
  static LOGIN_TYPE_DATA_PORTAL_USER = "D";
  static LOGIN_TYPE_SPECIAL_DATA_PORTAL_USER = "Z";

  static ROLE_EMPLOYEE = "EMPLYE";
  static ROLE_SALESPERSON = "SLSREP";
  static ROLE_CUSTOMER = "ROLE_CUSTOMER";
  static ROLE_DATA_PORTAL_CUSTOMER = "DPCUST";
  static ROLE_DATA_PORTAL_SALESPERSON = "DPSP";

  static INVOICE_PRINTOUT_LOGO_IMAGE_NAME_PREFIX = "IVP_";

  static CRITICAL_PATH_MANAGEMENT_APPROVE_STATUS = "A";   // Approve	
  static CRITICAL_PATH_MANAGEMENT_UNAPPROVE_STATUS = "U";   // UnApprove	
  static CRITICAL_PATH_MANAGEMENT_CLOSE_STATUS = "F";   // Finish	
  static CRITICAL_PATH_MANAGEMENT_CANCEL_STATUS = "X";   // Cancel	
  static CRITICAL_PATH_MANAGEMENT_OPEN_STATUS = "O";   //Open

  static CRITICAL_PATH_MANAGEMENT_LINE_OPEN_STATUS = "O";   // Open	
  static CRITICAL_PATH_MANAGEMENT_LINE_CANCEL_STATUS = "X";   // Cancelled becos of Vendor mistakes / problems
  static CRITICAL_PATH_MANAGEMENT_LINE_CLOSE_STATUS = "H";   // Closed. becos of the Company requirement // Manual Close

  static CRITICAL_PATH_MANAGEMENT_LINE_APPROVED_STATUS = "A";   // Approved.
  static CRITICAL_PATH_MANAGEMENT_LINE_REJECTED_STATUS = "R";   // Rejected.

  static CRITICAL_PATH_MANAGEMENT_LINE_EXCLUDED_STATUS = "E";   // Excluded.
  static CRITICAL_PATH_MANAGEMENT_LINE_FINISHED_STATUS = "F";   // Finished.



  static CRITICAL_PATH_MANAGEMENT_CREATE_TRACK_TYPE = "N";   // NEW	
  static CRITICAL_PATH_MANAGEMENT_UPDATE_TRACK_TYPE = "M";   // UPDATE // MODIFY	
  static CRITICAL_PATH_MANAGEMENT_APPROVAL_TRACK_TYPE = "A";   // Approve	
  static CRITICAL_PATH_MANAGEMENT_UNAPPROVAL_TRACK_TYPE = "U";   // Approve	
  static CRITICAL_PATH_MANAGEMENT_CANCEL_TRACK_TYPE = "X";	 // Cancel
  static CRITICAL_PATH_MANAGEMENT_FORCE_CLOSE_TRACK_TYPE = "Z";	 // Cancel







  static DEBIT_MEMO_OPEN_STATUS = "O";   // OPEN	
  static DEBIT_MEMO_APPROVE_STATUS = "A";   // Approve 	
  static DEBIT_MEMO_CANCEL_STATUS = "X";   // Cancel	
  static DEBIT_MEMO_FINISHED_STATUS = "F";   // Finish	
  static DEBIT_MEMO_PARTIALLY_CLOSED_STATUS = "P";	 // PartiallyClosed
  static DEBIT_MEMO_PARTIALLY_USED_AND_APPROVED_STATUS = "C";	 // PartiallyUsedAndApproved


  static DEBIT_MEMO_LINE_OPEN_STATUS = "O";   // OPEN	
  static DEBIT_MEMO_LINE_APPROVE_STATUS = "A";   // Approve 	
  static DEBIT_MEMO_LINE_CANCEL_STATUS = "X";   // Cancel	



  static DEBIT_MEMO_CREATE_TRACK_TYPE  = "N";   // OPEN	
  static DEBIT_MEMO_UPDATE_TRACK_TYPE  = "M";   // Approve 	
  static DEBIT_MEMO_APPROVE_TRACK_TYPE  = "A";   // Cancel	
  static DEBIT_MEMO_CANCEL_TRACK_TYPE  = "X";   // Finish	
  static DEBIT_MEMO_FINISH_TRACK_TYPE  = "F";	 // PartiallyClosed
  static DEBIT_MEMO_CLOSE_STATUS  = "F";	 // PartiallyUsedAndApproved

  static SALES_COMMISSION_TRANSACTION_OPEN_STATUS  = "O";                    // OPEN	
  static SALES_COMMISSION_TRANSACTION_FINISHED_STATUS  = "F";               // PAID
  static SALES_COMMISSION_TRANSACTION_CANCELLED_STATUS  = "X";             // CANCELLED	
  static SALES_COMMISSION_TRANSACTION_APPROVED_STATUS  = "A";             // Approved	
  static SALES_COMMISSION_TRANSACTION_OPEN_AND_APPROVED_STATUS  = "Z";	 // OPEN & APPROVED
  
}
